import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import isAfter from 'date-fns/is_after';
import endOfDay from 'date-fns/end_of_day';
import differenceInDays from 'date-fns/difference_in_days';

import {
  I18n,
  Link,
  Icon,
} from 'components';

import {
  formatDateString,
  formatUnitString,
} from 'utils/formatString';

import declint from 'utils/declint';

import {
  UI_DATE_FORMAT,
  STATUSES,
} from '../../constants';

import styles from './styles.pcss';

const cx = classNames.bind(styles);

const Status = ({
  status,
  dueDate,
  unpaidAmount,
  currency,
  paymentUrl,
}) => {
  if (status === STATUSES.PAID) {
    return (
      <div>
        <Icon name="check-circle" />
        <I18n
          className={cx('paid')}
          path="detalization.postpaidInvoices.paid"
        />
      </div>
    );
  }

  if (isAfter(endOfDay(dueDate), endOfDay(new Date()))) {
    if (!unpaidAmount) {
      return (
        <div>
          <I18n
            path="detalization.postpaidInvoices.notPaid"
            vars={{ date: formatDateString(dueDate, UI_DATE_FORMAT) }}
          />
          <br />
          <Link href={paymentUrl}>
            <I18n path="detalization.postpaidInvoices.billPayment" />
          </Link>
        </div>
      );
    }

    if (unpaidAmount > 0) {
      return (
        <div>
          <I18n
            path="detalization.postpaidInvoices.notPaidAmount"
            vars={{
              date: formatDateString(dueDate, UI_DATE_FORMAT),
              amount: formatUnitString(unpaidAmount, currency),
            }}
          />
          <br />
          <Link href={paymentUrl}>
            <I18n path="detalization.postpaidInvoices.billPayment" />
          </Link>
        </div>
      );
    }
  }

  if (!unpaidAmount) {
    return (
      <div>
        <I18n
          path="detalization.postpaidInvoices.overduePayment"
          vars={{ overdue: differenceInDays(dueDate, new Date()) }}
        />
        <br />
        <Link href={paymentUrl}>
          <I18n path="detalization.postpaidInvoices.billPayment" />
        </Link>
      </div>
    );
  }

  if (unpaidAmount > 0) {
    const overdue = differenceInDays(new Date(), dueDate);
    return (
      <div>
        <I18n
          path="detalization.postpaidInvoices.overduePaymentWithAmount"
          vars={{
            overdue,
            day: declint(overdue, ['день', 'дня', 'дней']),
            amount: formatUnitString(unpaidAmount, currency),
          }}
        />
        <br />
        <Link href={paymentUrl}>
          <I18n path="detalization.postpaidInvoices.billPayment" />
        </Link>
      </div>
    );
  }

  return null;
};

Status.propTypes = {
  status: PropTypes.string,
  dueDate: PropTypes.string,
  unpaidAmount: PropTypes.number,
  currency: PropTypes.string,
  paymentUrl: PropTypes.string,
};

export default Status;
